// extracted by mini-css-extract-plugin
module.exports = {"canvas":"useCanvasDraw_canvas__387Fy"};